<template>
  <div class="tw-drawer">
    <input id="my-drawer" type="checkbox" class="tw-drawer-toggle" />
    <div class="tw-drawer-content">
      <div class="tw-container tw-mx-auto">
        <section class="tw-flex tw-flex-row tw-justify-between tw-items-center tw-py-6">
          <NuxtLinkLocale to="/">
            <SvgoMenuHeaderLogo class="tw-h-[30px] md:tw-h-10 tw-fill-[#111224]" />
          </NuxtLinkLocale>
          <div class="tw-flex tw-flex-row tw-items-center tw-gap-2">
            <div v-for="(item, index) in menuList" class="tw-hidden md:tw-block">
              <NuxtLinkLocale v-if="item.href" :to="item.href">
                <button class="tw-btn tw-btn-ghost tw-text-accent tw-font-normal">{{ item.name }}</button>
              </NuxtLinkLocale>
            </div>

            <CommonLang />
            <label for="my-drawer" class="md:tw-hidden">
              <SvgoMenuMMenu class="tw-h-[30px] md:tw-h-10 tw-fill-[#111224] tw-stroke-[#111224]" />
            </label>
          </div>
        </section>
      </div>
    </div>
    <div class="tw-drawer-side tw-z-10">
      <label for="my-drawer" aria-label="close sidebar" class="tw-drawer-overlay"></label>
      <div class="tw-menu tw-bg-primary tw-text-base-content tw-min-h-full tw-w-full tw-p-4">
        <div role="dialog" aria-modal="true">
          <div class="tw-fixed tw-inset-0 tw-z-10" @touchmove.prevent></div>
          <div class="tw-fixed tw-inset-y-0 tw-right-0 tw-z-[999] tw-w-full tw-overflow-y-auto tw-bg-white tw-px-5">
            <div class="tw-flex tw-items-center tw-justify-between tw-py-4">
              <NuxtLinkLocale to="/">
                <SvgoMenuHeaderLogo class="tw-h-[30px] md:tw-h-10 tw-fill-[#111224]" />
              </NuxtLinkLocale>
              <label class="tw-w-[30px] tw-h-[30px] tw-cursor-pointer" for="my-drawer" aria-label="close sidebar">
                <SvgoMenuMMenuClose />
              </label>
            </div>
            <div class="tw-py-7 tw-flow-root">
              <div class="tw-flex tw-flex-col tw-gap-y-7 " >
                <NuxtLinkLocale v-for="(item, index) in menuList" :key="index" tag="label" for="my-drawer" aria-label="close sidebar" :to="item.href" class="tw-text-lg !tw-leading-relaxed">{{ item.name }}</NuxtLinkLocale>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script lang="ts" setup>
  const { t } = useI18n()

  const menuList = [
    {
      name: t('FAQ'),
      href: `/partner/faq`,
      key: 'faq',
      showMenu: false,
      child: [],
    },
    {
      name: t('Sign In'),
      href: `https://otc.legendtrading.com/partners/login`,
      key: 'signIn',
      showMenu: false,
      child: [],
    },
  ]
</script>
